import { pagination_params } from '../../shared/utils/pagination_params';

const appendPartialTextFilter = (path, params, field) => {
  const value = typeof params[field] === 'string' ? params[field].trim() : params[field];
  if (value && String(value).length >= 3) {
    return `${path !== '' ? `${path}&` : ''}${field}=${encodeURIComponent(value)}`;
  }
  return path;
};

export const getParamsUrl = (params) => {
  if (!params) return '';
  let path = '';
  path = pagination_params(params);

  params.Activo && (path = `${path !== '' ? `${path}&` : ''}Activo=${params.Activo}`);
  path = appendPartialTextFilter(path, params, 'CodigoSuaje');
  path = appendPartialTextFilter(path, params, 'CodigoAdicional');
  path = appendPartialTextFilter(path, params, 'Descripcion');
  path = appendPartialTextFilter(path, params, 'Observaciones');
  path = appendPartialTextFilter(path, params, 'Busqueda');
  params.CodigoSuajeTipo &&
    params.CodigoSuajeTipo.Codigo &&
    (path = `${path !== '' ? `${path}&` : ''}CodigoSuajeTipo=${params.CodigoSuajeTipo.Codigo}`);
  params.ClaveInternaSuajeTipo &&
    (path = `${path !== '' ? `${path}&` : ''}ClaveInternaSuajeTipo=${params.ClaveInternaSuajeTipo}`);
  params.CodigoRecurso &&
    (path = `${path !== '' ? `${path}&` : ''}CodigoRecurso=${params.CodigoRecurso}`);
  params.CodigoMateriaPrimaFamilia &&
    (path = `${path !== '' ? `${path}&` : ''}CodigoMateriaPrimaFamilia=${params.CodigoMateriaPrimaFamilia}`);

  // Filtros booleanos: siempre se envían (true o false)
  if (params.TienePleca !== undefined) {
    path = `${path !== '' ? `${path}&` : ''}TienePleca=${params.TienePleca}`;
  }
  if (params.EsAutomatica !== undefined) {
    path = `${path !== '' ? `${path}&` : ''}EsAutomatica=${params.EsAutomatica}`;
  }
  if (params.EsCorteCompleto !== undefined) {
    path = `${path !== '' ? `${path}&` : ''}EsCorteCompleto=${params.EsCorteCompleto}`;
  }

  params.Tolerancia && (path = `${path !== '' ? `${path}&` : ''}Tolerancia=${params.Tolerancia}`);
  params.Forma &&
    params.Forma.Codigo &&
    (path = `${path !== '' ? `${path}&` : ''}CodigoForma=${params.Forma.Codigo}`);
  if (params.MedidaEje) {
    const medidaEjeParam = params.UnidadMedida === 'mm' ? 'MedidaEjeMm' : 'MedidaEjeIn';
    path += `${path !== '' ? '&' : ''}${medidaEjeParam}=${params.MedidaEje}`;
  }

  if (params.MedidaDesarrollo) {
    const medidaDesarrolloParam =
      params.UnidadMedida === 'mm' ? 'MedidaDesarrolloMm' : 'MedidaDesarrolloIn';
    path += `${path !== '' ? '&' : ''}${medidaDesarrolloParam}=${params.MedidaDesarrollo}`;
  }

  params.EtiquetasEje &&
    (path = `${path !== '' ? `${path}&` : ''}EtiquetasEje=${params.EtiquetasEje}`);
  params.EtiquetasDesarrollo &&
    (path = `${path !== '' ? `${path}&` : ''}EtiquetasDesarrollo=${params.EtiquetasDesarrollo}`);

  return path;
};
